import React from 'react';

const IconGoogleScholar = () => (
  <svg xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 612 612">
    <title>Google Scholar</title>
    <path d="M256 411.12L0 202.667 256 0z" />
    <path d="M256 411.12l256-208.453L256 0z" />
    <circle cx="256" cy="362.667" fill="#a0c3ff" r="149.333" />
    <path d="M121.037 298.667c23.968-50.453 75.392-85.334 134.963-85.334s110.995 34.881 134.963 85.334H121.037z" />
  </svg>
);

export default IconGoogleScholar;
